import { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import {
  Box,
  Button,
  Form,
  FormField,
  ColumnLayout,
  Container,
  SpaceBetween,
  Header,
  Tiles,
  TextContent,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { COMMON_LABELS } from "../default-constants";
import {
  usePutApplicationMutation,
  usePutApplicationRejectMutation,
} from "../../features/api";
import { ApplicationRejectRequest } from "../../features/api-interfaces";
import { showModal } from "../UI/modal/modal-slice";
import { useAppDispatch } from "../../app/hook";

/*
 *申請情報更新画面
 */
export const ApplicationInformation = (props: any) => {
  const navigator = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const companyData = location.state;

  // 申請No
  const { no } = useParams();
  // 申請情報更新
  const [updateApplication] = usePutApplicationMutation();
  // 申請差戻
  const [rejectApplication] = usePutApplicationRejectMutation();

  //不備の有無
  const [defectFlag, setDefectFlag] = useState("0");

  // 登録ボタンクリック関数
  const handleOnSubmitClick = () => {
    let modalContent: string;
    let modalFunction: VoidFunction;
    if (Number(defectFlag)) {
      // 不備ありの時、差戻
      modalContent = "申請を差し戻します。";
      modalFunction = () => {
        const payload = {
          applicationNo: no ?? "",
          processType: 2,
          incompletionReason: "申請された手数料率の記載誤りのため",
        } as ApplicationRejectRequest;
        rejectApplication(payload).then((res: any) => {
          if (!("error" in res) && "error" !== res.data.status) {
            navigator(`/application-status/${no}`);
          }
        });
      };
    } else {
      // 不備なしのとき、承認
      modalContent = "手数料率不備なしで登録します。";
      modalFunction = () => {
        const reqParam = no ?? "";
        updateApplication(reqParam).then((res: any) => {
          if (!("error" in res) && "error" !== res.data.status) {
            navigator(`/application-status/${no}`);
          }
        });
      };
    }
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: modalContent,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: modalFunction,
      })
    );
  };

  const backBtnOnClick = () => {
    navigator(`/application-status/${no}`);
  };

  return (
    <SpaceBetween direction="vertical" size="l">
      <form onSubmit={(e) => e.preventDefault()}>
        <Form>
          <SpaceBetween direction="vertical" size="m">
            <Container>
              <SpaceBetween direction="horizontal" size="xs">
                <SpaceBetween size="xxs">
                  <TextContent>
                    <h4>{LABELS.CORP_NUMBER}</h4>
                  </TextContent>
                  <TextContent>
                    <h4>{LABELS.COMPANY_NAME}</h4>
                  </TextContent>
                  <TextContent>
                    <h4>{LABELS.COMPANY_ADDRESS}</h4>
                  </TextContent>
                  <TextContent>
                    <h4>{LABELS.MERCHANT_NAME}</h4>
                  </TextContent>
                </SpaceBetween>
                <SpaceBetween size="xxxs">
                  <TextContent>
                    <p>{companyData?.corporateNo}</p>
                  </TextContent>
                  <TextContent>
                    <p>{companyData?.companyName}</p>
                  </TextContent>
                  <TextContent>
                    <p>{companyData?.address}</p>
                  </TextContent>
                  <TextContent>
                    <p>{companyData?.merchantName}</p>
                  </TextContent>
                </SpaceBetween>
              </SpaceBetween>
            </Container>
            <Container>
              <SpaceBetween direction="vertical" size="l">
                <Header variant="h2">{LABELS.IMPORTANT_CONFIRM_ITEMS}</Header>
                <div>
                  <strong>{LABELS.APPLICATION_REJECTION_LABEL}</strong>
                </div>
                <SpaceBetween direction="horizontal" size="m">
                  <SpaceBetween size="xxs">
                    <TextContent>
                      <h4>{LABELS.COMMISSION_RATE}</h4>
                    </TextContent>
                  </SpaceBetween>
                  <SpaceBetween size="xxs">
                    <TextContent>
                      <h4>{companyData?.commissionRate}</h4>
                    </TextContent>
                  </SpaceBetween>
                  <SpaceBetween size="xxxs">
                    <TextContent>
                      <p>%</p>
                    </TextContent>
                  </SpaceBetween>
                </SpaceBetween>
                <FormField>
                  <Tiles
                    onChange={({ detail }) => setDefectFlag(detail.value)}
                    value={defectFlag}
                    items={[
                      { label: "不備なし", value: "0" },
                      { label: "不備あり（加盟店に差し戻す）", value: "1" },
                    ]}
                  />
                </FormField>
              </SpaceBetween>
            </Container>
            <ColumnLayout columns={2}>
              <Box float="left">
                <Button
                  iconAlign="left"
                  variant="link"
                  onClick={backBtnOnClick}
                >
                  {COMMON_LABELS.BTNS.BACK}
                </Button>
              </Box>
              <Box float="right">
                <Button
                  iconAlign="right"
                  onClick={handleOnSubmitClick}
                  variant="primary"
                >
                  {COMMON_LABELS.BTNS.REGISTER}
                </Button>
              </Box>
            </ColumnLayout>
          </SpaceBetween>
        </Form>
      </form>
    </SpaceBetween>
  );
};
export default ApplicationInformation;
